// extracted by mini-css-extract-plugin
export default {"title":"Login_title__PV6JS","navbar":"Login_navbar__syznJ","containerWrapper":"Login_containerWrapper__Q8UHe","btn_login":"Login_btn_login__DaQHN"};